import { searchParam, useSetSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { z } from 'zod/v4';

import { comparisonTabs } from '@/areas/comparison/Comparison/components/ComparisonTable/comparisonTabs';
import { NegotiationComparisonPage } from '@/areas/comparison/Comparison/NegotiationComparisonPage/NegotiationComparisonPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/compare')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    validateSearch: z.object({
        baseline: z.string().optional(),
        referenceA: z.string().optional(),
        referenceB: z.string().optional(),
        tab: searchParam.enum(comparisonTabs, 'optional'),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const tab = Route.useSearch({ select: (search) => search.tab });
    const setSearch = useSetSearch();
    return <NegotiationComparisonPage {...pathParams} tab={tab} onSearchChange={setSearch} />;
}
